import React, { Component } from 'react';

class Portfolio extends Component {
    render() {
        return (
            <div className="wrap">
                <div id="homepage_banner" class="jumbotron text-center">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                        </div>
                        <div class="col-md-4">
                            {/*<i id="thankspage_icons" class="fa fa-briefcase"></i>*/}
                            <h1 id="white_background_text"><b>My Work</b></h1>
                            <hr id="standard_line"></hr>
                        </div>
                        <div class="col-md-4">
                        </div>
                    </div>

                    
                    
                    {/*Portfolio Items*/}
                    <div class="row align-items-center">
                        <div class="col-md-4 portfolio_row">
                            <a class="portfolio_link" target="_blank" rel="noopener noreferrer" href="https://livexchanges.com">
                                <div class="card portfolio_card" id="portfolio_livexchanges">
                                    <div class="card-block portfolio_block">
                                        <h3 class="card-title portfolio_title">LIVEXCHANGES</h3>
                                        <h7 class="card-title portfolio_title">Stock and Cryptocurrency Alert Web App</h7>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-4 portfolio_row">
                            <a class="portfolio_link" target="_blank" rel="noopener noreferrer" href="https://heberlingagency.com">
                                <div class="card portfolio_card" id="portfolio_heberling">
                                    <div class="card-block portfolio_block">
                                        <h3 class="card-title portfolio_title">HEBERLING</h3>
                                        <h7 class="card-title portfolio_title">Insurance Agency Website</h7>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-4 portfolio_row">
                            <a class="portfolio_link" target="_blank" rel="noopener noreferrer" href="https://paduiclasses.org">
                                <div class="card portfolio_card" id="portfolio_padui">
                                    <div class="card-block portfolio_block">
                                        <h3 class="card-title portfolio_title">PADUI</h3>
                                        <h7 class="card-title portfolio_title">Online DUI Course</h7>
                                    </div>
                                </div>
                            </a>
                        </div>
                 
                    </div>
                    {/*Row 2*/}
                    <div class="row align-items-center">
                        <div class="col-md-4 portfolio_row">
                            <div class="card portfolio_card" id="portfolio_path_seeker">
                                <div class="card-block portfolio_block">
                                    <h3 class="card-title portfolio_title">Path Seeker</h3>
                                    <h7 class="card-title portfolio_title">Find Text in File or Directory</h7>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 portfolio_row">
                            <div class="card portfolio_card" id="portfolio_google_drive">
                                <div class="card-block portfolio_block">
                                    <h3 class="card-title portfolio_title">Google Drive</h3>
                                    <h7 class="card-title portfolio_title">Google Drive Bot</h7>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 portfolio_row">
                            <div class="card portfolio_card" id="portfolio_price_finder">
                                <div class="card-block portfolio_block">
                                    <h3 class="card-title portfolio_title">Price Finder</h3>
                                    <h7 class="card-title portfolio_title">Finds lowest prices of item online</h7>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }    
}
export default Portfolio;


// WEBPACK FOOTER //
// ./src/components/pages/portfolioPage.js